import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/claims/new/_layout')({
  component: RouteComponent,
  loaderDeps: ({ search }) => search,
});

function RouteComponent() {
  return (
    <div className="layout-sidebar">
      <Outlet />
    </div>
  );
}
